import { RuleObject } from 'antd/lib/form';
import dayjs, { Dayjs } from 'dayjs';
import * as pis from 'validation-br/dist/pisPasep';

/**
 * Valida se é um CPF válido
 * @param {string} cpf - valor a ser formatado
 * @returns {boolean} Se o CPF é válido
 */
export const validarCPF = (cpf: string) => {
  const cpfNumeros = cpf.replace(/\D/g, '');

  // Verificação de CPFs com todos os números iguais (111.111.111-11, etc)
  if (/^(\d)\1{10}$/.test(cpfNumeros)) {
    return false;
  }

  let soma = 0;
  let resto;

  for (let i = 1; i <= 9; i++) {
    soma = soma + parseInt(cpfNumeros.substring(i - 1, i)) * (11 - i);
  }

  resto = (soma * 10) % 11;

  if ((resto === 10) || (resto === 11)) {
    resto = 0;
  }

  if (resto !== parseInt(cpfNumeros.substring(9, 10))) {
    return false;
  }

  soma = 0;

  for (let i = 1; i <= 10; i++) {
    soma = soma + parseInt(cpfNumeros.substring(i - 1, i)) * (12 - i);
  }

  resto = (soma * 10) % 11;

  if ((resto === 10) || (resto === 11)) {
    resto = 0;
  }

  if (resto !== parseInt(cpfNumeros.substring(10, 11))) {
    return false;
  }

  return true;
};

export const validateEmail = (rule: any, value: string, callback: (error?: string) => void) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value) {
    callback('E-mail é obrigatório!');
  }
  if (!value.match(regex)) {
    callback('Por favor, insira um email válido!');
  } else {
    callback();
  }
};

export const validateCPF = (rule: RuleObject, value: string) => {
  if (!value) {
    if(rule.required === true){
      return Promise.reject('CPF é obrigatório.');
    }else{
      return Promise.resolve();
    }
  }

  if (!validarCPF(value)) {
    return Promise.reject('CPF inválido.');
  }
  return Promise.resolve();
};

/**
 * Validates when date is required, and validates that date is before currentDate
 * @param rule
 * @param value
 */
export const defaultEarlyDateValidator = async (rule: RuleObject, value?: Dayjs) => {
  if(!value){
    if(rule.required){
      throw new Error('Data deve ser informada');
    }
    return;
  }

  const currentDate = dayjs();

  if(value.isAfter(currentDate)){
    throw new Error('A data não pode ser maior que a data atual.');
  }
};

const validateVoterRegistrationNumber = (voterRegistrationNumber: string): boolean => {
  // Verifica se o Título de Eleitor tem exatamente 12 caracteres
  if (voterRegistrationNumber.length !== 12) {
    return false;
  }

  // Remove todos os caracteres não numéricos
  const tituloNumerico = voterRegistrationNumber.replace(/\D/g, '');

  // Verifica se após remover os caracteres não numéricos o tamanho ainda é 12
  if (tituloNumerico.length !== 12) {
    return false;
  }

  // Divide o número do título em partes
  const uf = tituloNumerico.substring(8, 10);
  const numeroBase = tituloNumerico.substring(0, 8);
  const digitoVerificador = tituloNumerico.substring(10);

  // Calcula o primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 8; i++) {
    soma += parseInt(numeroBase.charAt(i)) * (8 - i);
  }
  let resto = soma % 11;
  let dv1 = 11 - resto;
  if (dv1 === 10 || dv1 === 11) {
    dv1 = 0;
  }

  // Calcula o segundo dígito verificador
  soma = dv1 * 9;
  for (let i = 8; i >= 0; i--) {
    soma += parseInt(numeroBase.charAt(i)) * (9 - i);
  }
  resto = soma % 11;
  let dv2 = 11 - resto;
  if (dv2 === 10 || dv2 === 11) {
    dv2 = 0;
  }

  // Verifica se os dígitos verificadores calculados coincidem com os dígitos fornecidos
  return parseInt(digitoVerificador.charAt(0)) === dv1 && parseInt(digitoVerificador.charAt(1)) === dv2;
};

export const validatePISPASEP = async (rule: RuleObject,pisNumber : string) => {
  if(!pisNumber){
    if(rule.required)
      throw new Error('Número PIS/PASEP é obrigatório!');

    return;
  }
  if(!pis.validate(pisNumber)){
    throw new Error('Número PIS/PASEP é inválido!');
  }
};

export const validateMessages = {
  required: '${label} é obrigatório!',
  types: {
    email: '${label} não é um e-mail válido!',
    number: '${label} não é um número válido!',
  },
  number: {
    range: '${label} deve possuir entre ${min} e ${max} caracteres',
  },
};